<template>
    <div v-show="isLoaded" class="content-wrapper">
        <div class="common-form-wrapper no-print">
            <div class="common-form">
                <div class="tab-visibility">
                    <div class="visibility-label">{{ $t('settings.tabVisibilityTab.section_label') }}</div>
                    <div class="tab-visibility-settings">
                        <div v-for="tab in tabs" :key="tab.id">
                            <div class="chkbox-item">
                                <label>{{ tab.name }}</label>
                                <span v-if="tab.enabled === false" class="enabled-function">{{
                                    '(' + $t('settings.tabVisibilityTab.disabled_function') + ')'
                                }}</span>
                                <div class="chkbox">
                                    <input :id="tab.id" v-model="tab.value" type="checkbox" />
                                    <label :for="tab.id"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';
import mappingState from '../common/mappingState';
import sortBy from 'lodash-es/sortBy';
import { SUCCESS } from '../../constants';
import { resourceTabVisibility } from '../../api/resources';
import { getCancelToken } from '../../api';
import commonDirectives from '../common/commonDirectives';
import cloneDeep from 'lodash-es/cloneDeep';
import { ifIsNotCanceled } from '../common/helpers';

export default {
    mixins: [mappingState, commonDirectives],

    data() {
        return {
            cancelToken: getCancelToken(),
            tabs: [],
            tabsCopy: [],
            isLoaded: false,
        };
    },

    computed: {
        ...mapState(['isLoading', 'unsavedChanges']),
    },

    watch: {
        tabs: {
            handler() {
                this.setUnsavedChanges(true);
            },
            deep: true,
        },
    },

    created() {
        this.setSaveUndoButtons({
            undo: this.undo.bind(this),
            save: this.save.bind(this),
            saveDisabled: () => !this.unsavedChanges,
            wasChanged: () => !this.unsavedChanges,
        });
        this.showLoading(true);
        this.isLoaded = false;
        resourceTabVisibility()
            .then(res => {
                let visibility = {};
                Object.entries(res.data).forEach(
                    ([key, value]) => (visibility[key] = value.visible && value.enabled)
                );
                this.setTabVisibility(res.data);
                return res.data;
            })
            .then(data => {
                this.tabs = sortBy(
                    Object.entries(data).map(([key, value]) => {
                        return {
                            name: this.$t('settings.tabVisibilityTab.' + key),
                            id: key,
                            value: value.visible,
                            enabled: value.enabled,
                        };
                    }),
                    'name'
                );
                this.tabsCopy = cloneDeep(this.tabs);
            })
            .then(() => {
                this.showLoading(false);
                this.setUnsavedChanges(false);
                this.isLoaded = true;
            })
            .catch(ifIsNotCanceled());
    },

    beforeDestroy() {
        this.cancelToken.cancel();
    },

    methods: {
        ...mapActions({
            setTabVisibility: 'setTabVisibility',
        }),
        /**
         * Sends tab visibility settings to database
         */
        save() {
            if (this.unsavedChanges) {
                this.showLoading(true);
                let data = this.tabs.map(item => {
                    return { tab_path: item.id, visible: item.value };
                });
                return resourceTabVisibility({
                    method: 'post',
                    data: data,
                    cancelToken: this.cancelToken.token,
                })
                    .then(() => {
                        this.popup({
                            type: SUCCESS,
                            header: this.$t('common.success'),
                            text: this.$t('common.saved'),
                        });
                        this.setUnsavedChanges(false);
                        this.tabsCopy = cloneDeep(this.tabs);
                        let storeSettings = {};
                        this.tabs.forEach(tab => {
                            storeSettings[tab.id] = { visible: tab.value, enabled: tab.enabled };
                        });
                        this.setTabVisibility(storeSettings);
                        this.showLoading(false);
                    })
                    .catch(ifIsNotCanceled());
            }
        },

        /**
         * Reset tab visibility data to the previous saved data
         */
        undo() {
            this.tabs = cloneDeep(this.tabsCopy);
            this.$nextTick(() => {
                this.setUnsavedChanges(false);
            });
        },
    },
};
</script>
